module.exports = __webpack_public_path__ + "static/media/Replay-01.b1152405.svg";